import React from 'react'
import { ANIMATION_CONSTANTS, PLACEHOLDER_DATA } from './constants'
import { LoadingFlower } from './components/LoadingFlower'
import { DidYouKnowSection } from './components/DidYouKnowSection'
import { useFlowerAnimation } from './hooks'
import styles from './styles.module.scss'

/**
 * ResultCalculationPage displays an animated loading screen while calculating quiz results
 * and automatically redirects to the essentials page after a delay.
 */
export const ResultCalculationPage: React.FC = () => {
  const { activeFlowerIndex, isLoading, error, isCompleted } = useFlowerAnimation()

  const renderLoadingSection = () => (
    <div className={styles.loadingContainer}>
      <div className={styles.loadingText}>
        <span>CALCULATING YOUR RESULTS...</span>
      </div>
      <div className={styles.flowerLoading}>
        {Array.from({ length: ANIMATION_CONSTANTS.TOTAL_FLOWERS }).map((_, index) => (
          <LoadingFlower key={index} index={index} isActive={index === activeFlowerIndex} />
        ))}
      </div>
      {error && (
        <div className={styles.errorMessage}>
          <p>Error: {error}</p>
        </div>
      )}
    </div>
  )

  return (
    <div className={styles.resultCalculationPage}>
      <div className={styles.contentWrapper}>{renderLoadingSection()}</div>
      <DidYouKnowSection
        designerCount={PLACEHOLDER_DATA.DESIGNER_COUNT}
        weddingCount={PLACEHOLDER_DATA.WEDDING_COUNT}
      />
    </div>
  )
}

export default ResultCalculationPage
